import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';

import { InputErrorsDirective } from './input-errors.directive';

@NgModule({
  imports: [
    CommonModule,
    MaterialsModule,
    PipesModule,
  ],
  declarations: [
    InputErrorsDirective,
  ],
  exports: [
    InputErrorsDirective,
  ],
})
export class ErrorsModule { }
